{
  "messages": {
    "networkError": "Terjadi kesalahan jaringan. Jika masalah berlanjut, silakan hubungi kami.",
    "appointmentUpdatedValidationFailed": "Janji temu telah diperbarui, tetapi gagal dalam validasi eksternal.",
    "appointmentCreatedValidationFailed": "Janji temu telah dibuat, tetapi gagal dalam validasi eksternal.",
    "validationErrorDetail": "<br /> Kesalahan Validasi: {error}"
  },
  "titles": {
    "warehouseRuleFailed": "Aturan Gudang Gagal",
    "validationServerError": "Kesalahan Server Validasi",
    "appointmentUpdatedWithValidationError": "Janji temu diperbarui dengan kesalahan validasi",
    "appointmentCreatedWithValidationError": "Janji temu dibuat dengan kesalahan validasi"
  }
}
